<template>
  <div id="role_manage">
    <section class="searchForm">
      <el-form inline>
        <el-form-item label="角色名称">
          <el-input type="text"></el-input>
        </el-form-item>
        <el-form-item label="角色权限">
          <el-select>
            <el-option label="Zone one" value="shanghai" />
            <el-option label="Zone two" value="beijing" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">查询</el-button>
          <el-button type="primary">导出</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" :icon="Plus" @click="dialogVisible=true">添加角色</el-button>
    </section>
    <section class="tableList">
      <el-table :data="tableData">
        <el-table-column fixed prop="id" label="ID" width="80"/>
        <el-table-column fixed prop="name" label="角色名称" width="150"/>
        <el-table-column prop="right" label="角色权限"/>
        <el-table-column prop="explain" label="角色说明" width="250"/>
        <el-table-column prop="createTime" label="创建时间" width="180"/>
        <el-table-column fixed="right" label="操作" width="140">
          <template #default>
            <el-button size="small" type="primary" @click="dialogVisible=true">编辑</el-button>
            <el-button size="small" type="danger" @click="deleteRow">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <section class="pagination">
      <el-pagination
        v-model:currentPage="pageCurrent"
        v-model:page-size="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </section>

    <!-- 添加编辑弹窗 -->
    <el-dialog v-model="dialogVisible" title="添加" width="500px" draggable>
      <el-form label-width="100px">
        <el-form-item label="角色名称">
          <el-input type="text"></el-input>
        </el-form-item>
        <el-form-item label="角色权限">
          <el-checkbox-group v-model="checkedCities">
            <el-checkbox label="注册"></el-checkbox>
            <el-checkbox label="登录"></el-checkbox>
            <el-checkbox label="删除评论"></el-checkbox>
            <el-checkbox label="修改手机号"></el-checkbox>
            <el-checkbox label="注册"></el-checkbox>
            <el-checkbox label="登录"></el-checkbox>
            <el-checkbox label="删除评论"></el-checkbox>
            <el-checkbox label="修改手机号"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="角色说明">
          <el-input type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible=false">取消</el-button>
          <el-button type="primary" @click="dialogVisible=false">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { Plus } from '@element-plus/icons-vue'
import { ElMessageBox } from 'element-plus'
export default {
  data() {
    return {
      Plus: Plus,
      // 当前页码
      pageCurrent: 1,
      // 页面数据量
      pageSize: 10,
      // 总数据条数
      total: 1000,
      // 表格数据
      tableData: [
        {id:1,name: '管理员', right: "登陆，注册，删除", explain: '用户登录权限', createTime: '1254631636'},
        {id:1,name: '业务员', right: "登陆，注册，删除", explain: '用户注册权限', createTime: '1254631636'},
        {id:1,name: '系统管理员', right: "登陆，注册，删除", explain: '用户获取信息权限', createTime: '1254631636'},
        {id:1,name: '超级管理员', right: "登陆，注册，删除", explain: '用户获取信息权限', createTime: '1254631636'},
      ],
      // 权限选择结果
      checkedCities: [],
      // 添加编辑弹窗
      dialogVisible: false,
    }
  },
  mounted() {
    let query = this.$route.query;
    this.pageCurrent = Number(query.page || 1);
    this.pageSize = Number(query.size || 10);
    this.getCommentList();
  },
  methods: {
    // 页码改变触发
    handleCurrentChange() {
      this.$router.push({
        path: "/role_manage",
        query: { page: this.pageCurrent, size: this.pageSize },
      });
      this.getCommentList();
    },
    // 获取数据
    getCommentList() {},
    // 删除
    deleteRow() {
      ElMessageBox.alert('确认删除','提示',)
    }
  },
}
</script>
<style lang="scss">
#role_manage .el-checkbox {
  height: 20px !important;
  line-height: 20px !important;
  margin-right: 7px !important;
}
</style>